module.exports = __webpack_public_path__ + "static/media/Karixlogo.a54115d4.png";